(() => {
  const initialise = root => {
    root.querySelectorAll('.eleat-compact-gallery').forEach(gallery => {
      if (gallery.dataset.eleatCompactReady) return;
      const slider = gallery.querySelector('.images__swiper');
      const slides = [...gallery.querySelectorAll('.images__swiper-slide')];
      const previous = gallery.querySelector('.eleat-compact-gallery__previous');
      const next = gallery.querySelector('.eleat-compact-gallery__next');
      const current = gallery.querySelector('[data-eleat-gallery-current]');
      const total = gallery.querySelector('[data-eleat-gallery-total]');
      const thumb = gallery.querySelector('[data-eleat-gallery-thumb]');
      if (!slider || !slides.length || !previous || !next || !current || !total) return;
      gallery.dataset.eleatCompactReady = 'true';
      let frame = 0;
      const update = () => {
        frame = 0;
        const active = slides.findIndex(slide => slide.classList.contains('images__swiper-slide--active'));
        const index = Math.min(slides.length - 1, Math.max(0, slider.swiper?.activeIndex ?? active));
        current.textContent = String(index + 1);
        total.textContent = String(slides.length);
        const focusedControl = document.activeElement;
        previous.disabled = index === 0;
        next.disabled = index >= slides.length - 1;
        if (focusedControl === next && next.disabled && !previous.disabled) previous.focus({ preventScroll: true });
        if (focusedControl === previous && previous.disabled && !next.disabled) next.focus({ preventScroll: true });
        if (thumb) {
          thumb.style.width = `${100 / slides.length}%`;
          thumb.style.transform = `translateX(${index * 100}%)`;
        }
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(update);
      };
      previous.addEventListener('click', () => {
        slider.swiper?.slidePrev();
        schedule();
      });
      next.addEventListener('click', () => {
        slider.swiper?.slideNext();
        schedule();
      });
      gallery.addEventListener('keydown', event => {
        if (!window.matchMedia('(max-width: 767px)').matches || !slider.swiper) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          slider.swiper.slidePrev();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          slider.swiper.slideNext();
        }
      });
      const observer = new MutationObserver(schedule);
      slides.forEach(slide => observer.observe(slide, { attributes: true, attributeFilter: ['class'] }));
      update();
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(gallery)) return;
        observer.disconnect();
        cancelAnimationFrame(frame);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
